import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Flyover from '../../components/UI/Flyover';
import VoiceRecordButton from '../../components/voice/VoiceRecordButton';
import { sendTextMessage } from '../../actions/messageActions';

const InputChatUI = ({
    fileInputImgRef,
    fileInputDocRef,
    setAttachRect,
    attachBtnRef,
    handleSend,           // текст/файл submit
    inputRef,
    setText,
    setFile,
    userId,
    chatId,
    file,
    text,
    onVoiceFinished,
    onTypingChange
}) => {
    const dispatch = useDispatch();
    const [attachOpen, setAttachOpen] = useState(false); // 👉 сюда приходит панель записи
    const [inputReplacement, setInputReplacement] = useState(null); // 👉 сюда приходит панель записи

    const toggleAttach = () => {
        console.log("attachOpen", attachOpen);
        setAttachOpen(true);
    };

    const choosePhoto = () => fileInputImgRef.current?.click();
    const chooseDoc = () => fileInputDocRef.current?.click();
    const chooseGeo = () => {
        if (!navigator.geolocation) return;
        navigator.mediaDevices && navigator.geolocation.getCurrentPosition(
            (pos) => {
                const { latitude, longitude } = pos.coords || {};
                const link = `https://maps.google.com/?q=${latitude},${longitude}`;
                const txt = `📍 Моя геолокация: ${latitude.toFixed(5)}, ${longitude.toFixed(5)}\n${link}`;
                dispatch(sendTextMessage(chatId, { sender: userId, text: txt }));
            },
            () => { },
            { enableHighAccuracy: true, maximumAge: 60000, timeout: 10000 }
        );
    };

    const handleVoiceFinished = ({ blob, durationMs }) => {
        if (!blob || !blob.size) return;
        onVoiceFinished?.({ blob, durationMs }); // у тебя уже есть отправка файла голосового
    };

    return (
        <>
            <form
                className="ChatUI__input"
                onSubmit={(e) => { e.preventDefault(); handleSend(e); }}
            >
                {inputReplacement ? (
                    <div className="ChatUI__input-replaced">{inputReplacement}</div>
                ) : (
                    <>
                        <input
                            ref={inputRef}
                            type="text"
                            placeholder="Введите сообщение…"
                            value={text}
                            onChange={(e) => {
                                const value = e.target.value;
                                setText(value);
                                onTypingChange?.(value);
                            }}
                        />
                        <input
                            ref={fileInputImgRef}
                            type="file"
                            style={{ display: 'none' }}
                            accept="image/*,video/*"
                            onChange={(e) => { const f = e.target.files?.[0]; if (f) setFile(f); }}
                        />
                        <input
                            ref={fileInputDocRef}
                            type="file"
                            style={{ display: 'none' }}
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.zip,.rar,.7z"
                            onChange={(e) => { const f = e.target.files?.[0]; if (f) setFile(f); }}
                        />
                    </>
                )}

                {file && <span className="ChatUI__file-preview">{file.name}</span>}

                <div className="ChatUI__iconSendBlock">
                    <VoiceRecordButton
                        maxMs={5 * 60 * 1000}
                        onFinished={handleVoiceFinished}
                        onRecordUIReplace={(node) => setInputReplacement(node)}
                        onRecordUIRestore={() => setInputReplacement(null)}
                    />
                    {inputReplacement ? null : <>
                        <button type="submit" className="sendBtn" disabled={!text.trim() && !file} title="Отправить">➤</button>
                        <button type="button" className="attachBtn" ref={attachBtnRef} onClick={toggleAttach} title="Вложение">📎</button>
                    </>}
                </div>
            </form>

            {attachOpen && (
                <Flyover
                    anchorRef={attachBtnRef}
                    onClose={() => setAttachOpen(false)}
                    preferredPlacement="bottom"
                    align="end"
                    width={260}
                >
                    <div className="flyover__list">
                        <button className="flyover__item" onClick={() => { setAttachOpen(false); choosePhoto(); }}>
                            📷 Фото / 🎞 Видео
                        </button>
                        <button className="flyover__item" onClick={() => { setAttachOpen(false); chooseDoc(); }}>
                            📄 Документ
                        </button>
                        {/* <button className="flyover__item" onClick={() => { setAttachOpen(false); chooseGeo(); }}>
                            📍 Геолокация
                        </button> */}
                    </div>
                </Flyover>
            )}
        </>
    );
};

export default InputChatUI;
